import { useState } from "react";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Form, Input, Button, Checkbox, Card, message } from "antd";

import { loginUser } from "../../actions";
import { AUTHORIZATION_KEY } from "../../global_constants";

import AccountHook from "../../hooks/account";
import { displayBackendApiError } from "../../helpers";

const Login = ({ setAccountData }) => {
  const [form] = Form.useForm();
  const [processing, setProcessing] = useState(false);

  function onSubmit(values) {
    setProcessing(true);
    loginUser(values)
      .then((response) => {
        setProcessing(false);
        setAccountData(response);
        localStorage.setItem(AUTHORIZATION_KEY, response.access_token);
      })
      .catch((err) => {
        setProcessing(false);
        displayBackendApiError(err, "Unknown error occurred.");
      });
  }

  return (
    <div className="login-page">
      <Card bordered>
        {/* <div className="image-card"></div> */}
        <h3 style={{ marginBottom: "15px", textAlign: "center" }}>Welcome Back! 👋</h3>
        <Form
          form={form}
          onFinish={(values) => onSubmit(values)}
          layout="vertical"
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input
              size="middle"
              placeholder="Email"
            />
          </Form.Item>
          <Form.Item
            label="Password"
            name="password"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
              },
              {
                min: 4,
                message: "The Password must be at least 4 characters long",
              },
            ]}
          >
            <Input.Password
              size="middle"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item noStyle>
            <Button
              block
              type="primary"
              className="mt-12"
              htmlType="submit"
              loading={processing}
            >
              LOG IN
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};
export default AccountHook(Login);